<app-toolbar class="toolbar" id="kt_toolbar">
  <div class="subheadertoolbar">
    <div class="position-relative home-search">
      <span class="svg-icon svg-icon-2 svg-icon-lg-1 svg-icon-primary position-absolute top-50 ms-5 translate-middle-y">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="black" />
          <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="black" />
        </svg>
      </span>
      <input type="search" [(ngModel)]="searchText"
             placeholder="Search" class="form-control bnsights-control ps-15" />
    </div>
  

    <!-- <form [formGroup]="HomeSearch">
    <BBSF-TextBox [options]="searchTextBox" [group]="HomeSearch" [(ngModel)]="searchText"></BBSF-TextBox>
  </form> -->
  </div>
</app-toolbar>

<div class="container-fluid">
  <div class="row g-6 g-xl-9 mb-6 mb-xl-9">
    <div class="col-md-6 col-lg-3 col-xl-3" *ngFor="let card of cards | filter : searchText">
      <a class="card h-100" [routerLink]="[card.link]" routerLinkActive="router-link-active">
        <div class="card-body d-flex justify-content-center text-center flex-column p-8">
          <div class="text-gray-800 text-hover-primary d-flex flex-column">
            <div class="symbol symbol-75px mb-5">
              <span [inlineSVG]="card.img" class="svg-icon svg-icon-2 svg-icon-dark"></span>
            </div>
            <div class="fs-5 fw-bolder mb-2">{{card.title}}</div>
          </div>
        </div>
      </a>
    </div>
  </div>
</div>


